var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOurDna(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3171 13.1829L13.5554 13.265C17.4662 14.6114 22.1761 13.3239 25.5 10M13.3171 13.1829L12.6482 12.9527C8.99818 11.6961 4.6023 12.8976 1.5 16M13.3171 13.1829L13.235 12.9446C11.8886 9.03377 13.1761 4.32389 16.5 1M13.3171 13.1829L13.5473 13.8518C14.8039 17.5018 13.6024 21.8976 10.5 25",
    stroke: "#1D458C",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1 16.5999L13.3117 18.906M7.21759 12.8119L8.70001 14.2942",
    stroke: "#1D458C",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3125 6.71759L15.8999 9.40001M18.2999 11.8L19.4066 12.8117",
    stroke: "#1D458C",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.89972 14.2L8.09972 18.4",
    stroke: "#1D458C",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.834 11.6687L18.634 7.46875",
    stroke: "#1D458C",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2656 20.4297L12.17 22.3341",
    stroke: "#1D458C",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6044 5.30427L14.7 3.39984",
    stroke: "#1D458C",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOurDna);
export default __webpack_public_path__ + "static/media/our-dna.39646b3aef695151b0343b1ef1b30896.svg";
export { ForwardRef as ReactComponent };